;$(function () {

    let opened = null;

    function close(element) {

        element.removeClass('accordion_opened');
        element.find('[accordion-group-items]').slideUp(250);
        opened = null;

    }


    function open(element, fast) {

        element.addClass('accordion_opened');
        element.find('[accordion-group-items]').slideDown(fast ? 0 : 250);
        opened = element;

    }


    $(document).on('mousedown', '[accordion-group-header]', function () {

        let element = $(this).closest('[accordion-group]'),
            needToOpen = true;

        if (opened) {
            if (element.hasClass('accordion_opened')) needToOpen = false;
            close(opened);
        }

        if (needToOpen) open(element);

    });


    $(document).ready(function () {

        const firstOpen = $('[accordion_opened]');
        if (firstOpen.length)
            open(firstOpen, true);
        else
            open($('[accordion-group]').eq(0), true);

    });

    $(document).on('click', '#read-more', function () {
      $('#read-more').toggle();
      $('#more-text').toggle();
    })

    $(document).on('click', '#read-hide', function () {
      $('#read-more').toggle();
      $('#more-text').toggle();
    })

});
